import { dateSafariCompatible } from '@app/helpers/date';

export const hasDatePassed = (date: string) =>
  dateSafariCompatible(date) < new Date();
